/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1LocationStatesId200,
  GetApiV1LocationStatesId401,
  GetApiV1LocationStatesId404,
  GetApiV1LocationStatesId500,
  GetApiV1LocationStatesIdPathParams,
  GetApiV1LocationStatesIdQueryResponse,
} from "../../types/locationStateController/GetApiV1LocationStatesId.ts";
import { stateViewModelSchema } from "../stateViewModelSchema.ts";

export const getApiV1LocationStatesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1LocationStatesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1LocationStatesId200Schema = z.lazy(
  () => stateViewModelSchema,
) as unknown as ToZod<GetApiV1LocationStatesId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1LocationStatesId401Schema =
  z.any() as unknown as ToZod<GetApiV1LocationStatesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1LocationStatesId404Schema =
  z.any() as unknown as ToZod<GetApiV1LocationStatesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1LocationStatesId500Schema =
  z.any() as unknown as ToZod<GetApiV1LocationStatesId500>;

export const getApiV1LocationStatesIdQueryResponseSchema = z.lazy(
  () => getApiV1LocationStatesId200Schema,
) as unknown as ToZod<GetApiV1LocationStatesIdQueryResponse>;
